<template>
    <div class="time-interval-popup">
        <button class="btn-modern" @click.prevent="togglePopup">
            <i class="fa fa-clock"></i>
        </button>
        <div v-if="showPopup" class="popup-content" :style="{ top: popupTop }">
            <ul>
                <li v-for="interval in intervals" :key="interval.value" @click="selectInterval(interval)">
                    <span>{{ calculateNewTime(interval.value) }}</span>
                    <span class="interval-label">{{ interval.label }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, nextTick, onMounted } from 'vue';

const { proxy } = getCurrentInstance();

const props = defineProps({
    startTime: { type: String, required: true },
    defaultInterval: { type: Number, default: 30 }
});

const emit = defineEmits(['interval-selected']);

const showPopup = ref(false);
const popupTop = ref('100%');

const intervals = ref([
    { label: '30 minutos', value: 30 },
    { label: '1 hora', value: 60 },
    { label: '1:30 horas', value: 90 },
    { label: '2 horas', value: 120 },
    { label: '2:30 horas', value: 150 }
]);

const togglePopup = async (event) => {
    showPopup.value = !showPopup.value;
    if (showPopup.value) {
        proxy.$eventBus.emit('close-other-dropdowns', 'TimeIntervalPopup');
        await nextTick();
        adjustPopupPosition(event);
    }
};

const adjustPopupPosition = (event) => {
    const popup = event.target.closest('.time-interval-popup').querySelector('.popup-content');
    if (!popup) return;

    const rect = popup.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < popup.offsetHeight && spaceAbove > spaceBelow) {
        popupTop.value = `-${popup.offsetHeight}px`; // Ajusta hacia arriba si no hay espacio abajo
    } else {
        popupTop.value = '100%'; // Mantiene la posición normal si hay espacio abajo
    }
};

const selectInterval = (interval) => {
    emit('interval-selected', interval.value);
    showPopup.value = false;
};

const calculateNewTime = (interval) => {
    const startDate = new Date(props.startTime);
    startDate.setMinutes(startDate.getMinutes() + interval);
    let hours = startDate.getHours();
    const minutes = String(startDate.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
};

// Cerrar el popup si se hace clic fuera
onMounted(() => {
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.time-interval-popup')) {
            showPopup.value = false;
        }
    });
});
</script>

<style scoped>
.time-interval-popup {
    position: relative;
    display: inline-block;
    float: right;
    top: 6px;
    right: 1px;
}

.btn-modern {
    border: none;
    border-radius: 4px;
    /* Hacer el botón cuadrado */
    width: 24px;
    /* Ajustar el tamaño del botón */
    height: 24px;
    /* Ajustar el tamaño del botón */
    background: linear-gradient(135deg, #007bff, #0056b3);
    color: white;
    font-size: 12px;
    /* Ajustar el tamaño del icono */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.btn-modern:hover {
    background: linear-gradient(135deg, #0056b3, #004494);
    transform: scale(1.1);
}

.popup-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border: 1px solid #ccc;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    width: 220px;
    border-radius: 8px;
    overflow: hidden;
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    opacity: 1;
}

.popup-content ul {
    list-style: none;
    margin: 0;
    padding: 10px;
}

.popup-content li {
    padding: 12px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background 0.2s ease-in-out;
}

.popup-content li:hover {
    background: rgba(0, 123, 255, 0.2);
}

.interval-label {
    font-size: 0.9em;
    color: #555;
}
</style>